var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPorteria(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Porteria",
    xmlns: "http://www.w3.org/2000/svg",
    width: 233.129,
    height: 233.128,
    viewBox: "0 0 233.129 233.128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #262626;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    className: "cls-1",
    d: "M218.432,349.274a5.58,5.58,0,1,0,3.941-1.634A5.58,5.58,0,0,0,218.432,349.274Z",
    transform: "translate(-116.639 -187.034)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    className: "cls-1",
    d: "M443.067,393.55a5.586,5.586,0,1,0,3.941,1.639A5.586,5.586,0,0,0,443.067,393.55Z",
    transform: "translate(-240.055 -211.735)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    className: "cls-1",
    d: "M228.574,121.12H208.524v-38.2A22.847,22.847,0,0,0,190.7,60.739l-14.883-3.264a23.83,23.83,0,0,0,8.355-18.123V23.886a23.886,23.886,0,1,0-47.773,0v15.47a23.826,23.826,0,0,0,8.342,18.11L129.857,60.73a22.847,22.847,0,0,0-17.839,22.18V102.9h-24.6a4.56,4.56,0,0,0-4.555,4.555V121.12H51V108.368H70.116a4.555,4.555,0,0,0,4.555-4.551V54.641a4.555,4.555,0,0,0-4.555-4.555H4.555A4.551,4.551,0,0,0,0,54.641v49.176a4.551,4.551,0,0,0,4.555,4.551H23.672V121.12H4.555A4.551,4.551,0,0,0,0,125.67v21.858a4.551,4.551,0,0,0,4.555,4.551H20.049v76.494a4.551,4.551,0,0,0,4.537,4.555H208.543a4.551,4.551,0,0,0,4.551-4.555v-22.31a4.555,4.555,0,0,0-9.106,0v17.76H29.141V171.2H87.423a4.555,4.555,0,1,0,0-9.106H29.141V152.079H203.988v17.76a4.555,4.555,0,0,0,9.106,0v-17.76h15.48a4.551,4.551,0,0,0,4.555-4.551V125.67a4.551,4.551,0,0,0-4.555-4.551ZM145.5,36.13h6.266a41.884,41.884,0,0,0,23.313-6.994v10.22a14.78,14.78,0,0,1-29.561,0Zm14.78,27.113a23.9,23.9,0,0,0,4.154-.368l-4.2,9.484-4.22-9.507A23.948,23.948,0,0,0,160.276,63.243Zm0-54.137a14.8,14.8,0,0,1,13.731,9.325,32.843,32.843,0,0,1-22.245,8.612H145.5V23.886A14.8,14.8,0,0,1,160.276,9.106ZM121.11,82.91a13.675,13.675,0,0,1,10.682-13.284l15.713-3.446,8.546,19.242a4.555,4.555,0,0,0,8.323,0l8.546-19.247,15.811,3.46a13.671,13.671,0,0,1,10.691,13.284v38.2H150.261V107.458a4.56,4.56,0,0,0-4.555-4.555H121.12Zm-29.141,29.1H141.15v9.111H91.979ZM9.106,59.215H65.565v40.07H50.925a13.661,13.661,0,0,0-27.178,0H9.106Zm23.677,41.5a4.555,4.555,0,1,1,9.106,0v20.455H32.783Zm191.24,42.308H9.106V130.226H224.023Z",
    transform: "translate(0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPorteria);
export default __webpack_public_path__ + "static/media/Porteria.132a5e546ff132700273d3936d7e3fae.svg";
export { ForwardRef as ReactComponent };